import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import { NavContext } from '../../../context/global_context'
import { useParams } from 'react-router-dom'
import { postRequest } from '../../../services/base'
import MemosRow from './TracerMemosRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import { MemoContext, SHOW_FETCH_MEMO_POPUP } from './context/context'
import MemoHeader from './MemoHeader'

const TracerMemos = ({ getListData }) => {
  let { vehicle } = useParams()

  const [memos, setMemos] = useState([])
  const [atMemos, setAtMemos] = useState({})
  const [totalMemos, setTotalMemos] = useState(10)
  const [selectedItem, setSelectedItem] = useState({})

  const [state, dispatch] = useContext(NavContext)
  const [memoState, memoDispatch] = useContext(MemoContext)

  useEffect(() => {
    if (memoState.show_fetch_memo_popup) {
      importAllFromTracer()
    }
  }, [memoState.show_fetch_memo_popup])

  const importAllFromTracer = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching memos from Tracer',
        showLoader: true,
      },
      notification: {},
    })

    let formData = new FormData()
    formData.append(
      'updated_after',
      memoState.memos_date ? memoState.memos_date : ''
    )

    let res = await postRequest(
      `/api/dtc_memos/tracer_memos/${vehicle}/`,
      formData
    )
    if (res?.status) {
      if (!res.data.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.data.data,
          },
        })
      } else {
        setMemos(filterMemos(res.data.data.memos, res.at_memos))
        setAtMemos(res.at_memos)
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Completed memos fetching from Tracer',
          },
        })
      }
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res.msg,
        },
      })
    }
  }

  const filterMemos = (tracerMemos, atMemos) => {
    return tracerMemos.filter(
      (memo) =>
        memo.memo != atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.memo ||
        memo.short_desc !=
          atMemos?.[`${memo?.dtc}_${memo?.acronym}`]?.description
    )
  }

  const loadMoreMemos = () => {
    if (memos.length > totalMemos) {
      setTotalMemos(totalMemos + 10)
    }
  }

  const memoAction = async (action, index) => {
    if (action == 'accept') {
      let res = await postRequest(
        `/api/dtc_memos/action/${vehicle}/`,
        selectedItem
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res.msg,
          },
        })

        let tempMemos = [...memos]
        tempMemos.splice(index, 1)
        setMemos(tempMemos)
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res.msg,
          },
        })
      }
    } else {
      let tempMemos = [...memos]
      tempMemos[index]['status'] = 'rejected'
      setMemos(tempMemos)
    }
  }

  return (
    <Modal
      onClose={() => {
        getListData()
        memoDispatch({ type: SHOW_FETCH_MEMO_POPUP, data: false })
      }}
      show={memoState.show_fetch_memo_popup}
      size={`w-4\/5`}
    >
      <ModalHeader className={'text-white'}>
        Crowdsourced Memos Review
      </ModalHeader>
      <ModalBody>
        <div className="">
          <div className="font-light">
            <MemoHeader />
            {memos.slice(0, totalMemos)?.map((memo, index) => {
              return (
                <MemosRow
                  {...memo}
                  key={`memo-${index}`}
                  setSelectedItem={setSelectedItem}
                  selectedItem={selectedItem}
                  memoAction={(action) => {
                    memoAction(action, index)
                  }}
                  index={index}
                  showAction={true}
                  atMemo={atMemos?.[`${memo?.dtc}_${memo?.acronym}`]}
                />
              )
            })}
            {memos?.length < 1 && <NoRecordsFound />}
            {memos.length > totalMemos && (
              <div className="flex flex-row w-full text-white px-3 underline text-blue-500 font-normal justify-end">
                <span
                  onClick={() => {
                    loadMoreMemos()
                  }}
                  className="underline cursor-pointer"
                >
                  Load More
                </span>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default TracerMemos
